import { render, staticRenderFns } from "./cms-block-text-and-image.vue?vue&type=template&id=fa4eb05a&scoped=true"
import script from "./cms-block-text-and-image.vue?vue&type=script&lang=js"
export * from "./cms-block-text-and-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4eb05a",
  null
  
)

export default component.exports